import React, {Component} from 'react';
import Drawer from '@material-ui/core/Drawer';
import MenuItem from '@mui/material/MenuItem';
import {NavLink, withRouter} from 'react-router-dom';

import Tooltip from '@material-ui/core/Tooltip';
import {connect} from 'react-redux';
import {loadMenu} from '../common-redux/common.actions';
import saganLogo from '../images/sagan-logo.svg';
import Auth from '../auth/auth';
import NotificationBell from '../components/notification-bell';
import {CONTEXT_ENABLED} from '../config/features';

const auth = new Auth();
const {getRoleId} = auth;


class MainMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      docked: true,
      menuInput: '',
      contextOptionsMenu: false,
      contextMenuPosition: null,
    };
    this.props.getMenuItems();
  }

  componentDidMount() {
    this.setState({
      open: true,
      docked: true,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.isMobile !== prevProps.isMobile) {
      if (!prevProps.isMobile) {
        this.setState({open: false, docked: false});
      } else {
        this.setState({open: true, docked: true});
      }
    }
  }

  handleContextMenu=(e)=>{
    this.setState({
      contextOptionsMenu: !this.state.contextOptionsMenu,
      contextMenuPosition: e.currentTarget,
    });
  };

  closeContextMenu=()=>{
    this.setState({contextOptionsMenu: false});
  };


  handleToggle = () => {
    this.setState({open: !this.state.open});
  };

  shouldRefresh=(pagename) =>{
    const index = window.location.href.lastIndexOf('/');
    const currentPage = window.location.href.substring(index, window.location.href.length);
    if (pagename===currentPage) {
      window.location.reload();
    }
  };

  handleClose = () => { // alert(this.className);
    if (this.props.isMobile===true) {
      this.setState({open: false});
    }
  };

  logout() {
    auth.logout();
  }

  render() {
    // const displayName = String(this.state.profile.nickname).replace(/\./g,' ');
    const displayName = localStorage.getItem('saganUsername');
    const currentContext = JSON.parse(localStorage.getItem('context'));
    const allowFallbackMenu = process.env.NODE_ENV !== 'production' && process.env.REACT_APP_RBAC_FALLBACK_MODE === 'true';


    const urlFeatureMap = {
      '/lineage-library': 'data_lineage',
      '/data-dictionary-view': 'data_dictionary_view',
      '/schema-monitor': 'schema_monitoring',
      '/settings': 'data_dictionary_import',
      '/change-control': 'workflow',
    };

    return (
      <div className='menu-container'>
        <div className={(this.state.open ? 'mobile-menu-icon hidden-lg hidden-md hidden-sm clicked' : 'mobile-menu-icon hidden-lg hidden-md hidden-sm')} onClick={this.handleToggle}>
          <span>
            <span className='top'><hr /></span>
            <span className='middle'><hr /></span>
            <span className='bottom'><hr /></span>
          </span>
        </div>
        <Drawer variant={this.state.docked ? 'permanent' : 'temporary'}
          anchor="left"
          PaperProps={{className: 'menu-content-container', style: {width: 60}}}
          ModalProps={{BackdropProps: {className: 'menu-overlay'}}}
          open={this.state.open}
          onClose={() => this.setState({open: false})}>
          <div className="sk-in-app-logo hide"><img src={saganLogo} align="center" alt="Skokie" /></div>
          <div className='product-title'><span>S</span><span>K</span><span>O</span><span>K</span><span>I</span><span>E</span></div>
          {
          CONTEXT_ENABLED && currentContext !== null ?
          <div className="context-menu">
            <NavLink exact to="/context" className='menu-item context-menu-select'><Tooltip title={'Your are in: '+currentContext.contextName} placement="right"><MenuItem className='menu-item' onClick={this.handleClose}>{currentContext.contextName.substr(0, 1)}</MenuItem></Tooltip></NavLink>
          </div> : null
          }

          <div className='welcome'>
            <div className='welcome-text'>Welcome</div>
            <div className='user'>{displayName}</div>
          </div>
          <div className='menu-items'>
            {
          allowFallbackMenu || getRoleId() !== 1 ?
          this.props.menuItems.map((menuItems, index) => {
            if (menuItems.visible===true) {
              const featureName = urlFeatureMap[menuItems.url];
              if (featureName && !auth.hasPermission(featureName, 'can_view')) {
                return null;
              }
              return (
                <NavLink exact to={menuItems.url} activeClassName='active' className='menu-item' key={index}><Tooltip title={menuItems.label} placement="right"><MenuItem data-testid={'nav-' + menuItems.url.replace(/^\//, '')} className='menu-item' onClick={this.shouldRefresh.bind(this, menuItems.url)}><span className='material-icons'>{menuItems.name}</span></MenuItem></Tooltip></NavLink>
              );
            }
            return null;
          }) : null
            }


            {
          (CONTEXT_ENABLED && currentContext === null) ? null :
          <NavLink exact to="/settings" className='menu-item'><Tooltip title={'Manage Settings'} placement="right"><MenuItem data-testid="nav-settings" className='menu-item' onClick={this.handleClose}><span className='material-icons'>settings</span></MenuItem></Tooltip></NavLink>
            }

            {
          getRoleId()===1 ?
          <NavLink exact to="/admin" className='menu-item'><Tooltip title={'Admin Panel'} placement="right"><MenuItem data-testid="nav-admin" className='menu-item' onClick={this.handleClose}><span className='material-icons'>admin_panel_settings</span></MenuItem></Tooltip></NavLink> : null
            }


          </div>
          <div className='profile'>
            {
        getRoleId()===1 ?
        <NavLink exact to="/adminprofile" className='menu-item'><Tooltip title={'Hello '+displayName} placement="right"><MenuItem data-testid="nav-profile" className='menu-item' onClick={this.handleClose}><span className='material-icons'>account_circle</span></MenuItem></Tooltip></NavLink> :
        <NavLink exact to="/profile" className='menu-item'><Tooltip title={'Hello '+displayName} placement="right"><MenuItem data-testid="nav-profile" className='menu-item' onClick={this.handleClose}><span className='material-icons'>account_circle</span></MenuItem></Tooltip></NavLink>
            }

          </div>

          <div className='notifications-bell'>
            <NotificationBell />
          </div>


          <div className='sign-out'>

            <div data-testid="logout-btn" className='icon-button' onClick={this.logout.bind(this)}>
              <i className="material-icons">arrow_back</i>
              <div>Log out</div>
            </div>

          </div>

        </Drawer>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    menuItems: state.commonReducer.menuItems,
  };
};


export const mapDispatchToProps = (dispatch) => {
  return {
    getMenuItems: () => {
      dispatch(loadMenu());
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MainMenu));
